export default "__VITE_ASSET__K5VX0uFI__"